import { CfLoader } from "@/shared/components/common/CfLoader/CfLoader";

import { PrimaryButton } from "../primary-button/primary-button";

type Props = React.PropsWithChildren<{
  "data-testid"?: string;
  /**
   * should be used to disable form after its submission, not in a way to prevent user from submitting invalid form.
   */
  disabled?: boolean;
  pending: boolean;
  onClick?: () => void;
  fullWidth?: boolean;
}>;

const SubmitButton = ({
  children,
  "data-testid": dataTestId,
  disabled,
  fullWidth = true,
  onClick = () => {},
  pending,
}: Props) => (
  <PrimaryButton
    data-testid={dataTestId}
    disabled={pending || disabled}
    fullWidth={fullWidth}
    onClick={onClick}
    type="submit"
    variant="full"
  >
    {pending ? <CfLoader color="inherit" size={20} /> : children}
  </PrimaryButton>
);

export { SubmitButton };
